import { useExperiments } from "@backmarket/nuxt-module-experiments/useExperiments";
import { getMarkets } from "../utils/getMarkets.js";
export function useMarkets() {
  const experiments = useExperiments();
  const enableEsUsContent = experiments["experiment.enableEsUsContent"] !== "disabled";
  return getMarkets(enableEsUsContent);
}
